import React, { useEffect, useState } from "react";
import axios from "axios";
import "../css/vehicle.css";
import useAuthRedirect from "../hooks/useAuthRedirect";
import AdminNav from "../components/adminNav";

import Time from "../components/time";
import Swal from "sweetalert2";
import { hasPermission } from "../utils/permissionHelper";
import Access from "../components/access";

import { useParams, useNavigate, Link } from "react-router-dom"; // Import useNavigate

const EditHireVehicle = () => {
  useAuthRedirect();
    const { id } = useParams();
  const navigate = useNavigate(); // Initialize navigate function
 const [branches,setbranches] = useState([]);
   const [vehtypes,setvehtypes] = useState([]);
   const userName = localStorage.getItem("username"); // Default branch from storage
   const [selectedBranch, setSelectedBranch] = useState(localStorage.getItem("branch") || "");
  const [formData ,setFormData] = useState({
     fld_date: "" ,branch_code: "" ,fld_vehno: "" ,fld_vcode: "" ,fld_vname: "" ,fld_vtype: "" ,fld_vbasis: "" ,fld_vcompanyname : "",
     fld_ownersname: "" ,fld_vprice: "" ,fld_contactperson: "" ,fld_address1: "" ,fld_address2: "" ,fld_city: "" ,fld_phone: "" ,
     fld_vehappperiod: "" ,fld_fcexpire: "" ,fld_icexpire: "" ,fld_food: "" ,fld_tds: "" ,fld_mobile: "" ,fld_permitexpire: "" ,
     fld_dieselappr: "" ,fld_remarks: "" ,fld_panno: "" ,fld_panaddress: "" ,fld_panname: "" , fld_favouring: "" , fld_HireModel : ""
  
    });

    const canEdit = hasPermission("Hire Vehicle Registration", "edit");

    useEffect(() => {
        axios.get("https://rfs2.infraconsoft.net.in/api/get_branches")
          .then((response) => {
            setbranches(response.data.branches);
          })
          .catch((error) => {
            console.error("Error fetching branches:" ,error);
          });
      } ,[]);
    
       useEffect(() => {
        axios.get("https://rfs2.infraconsoft.net.in/api/get_vehicle_types")
          .then((response) => {
            setvehtypes(response.data.vehtypes);
          })
          .catch((error) => {
            console.error("Error fetching data:" ,error);
          });
      } ,[]);


  useEffect(() => {
    const fetchLocation = async () => {
      try {

        const response = await axios.get(
          `https://rfs2.infraconsoft.net.in/api/get_edit_hire_vehicle_api/${id}`
        );
        setFormData({
            fld_date: response.data.fld_date,
            branch_code: response.data.branch_code,
            fld_vehno: response.data.fld_vehno,
            fld_vcode: response.data.fld_vcode,
            fld_vname: response.data.fld_vname,
            fld_vtype: response.data.fld_vtype,
            fld_vbasis: response.data.fld_vbasis,
            fld_vcompanyname: response.data.fld_vcompanyname  ,
            fld_ownersname: response.data.fld_ownersname,
            fld_vprice: response.data.fld_vprice,
            fld_contactperson: response.data.fld_contactperson,
            fld_address1: response.data.fld_address1,
            fld_address2: response.data.fld_address2,
            fld_city: response.data.fld_city,
            fld_phone: response.data.fld_phone,
            fld_vehappperiod: response.data.fld_vehappperiod,
            fld_fcexpire: response.data.fld_fcexpire,
            fld_icexpire: response.data.fld_icexpire,
            fld_food: response.data.fld_food,
            fld_tds: response.data.fld_tds,
            fld_mobile: response.data.fld_mobile,
            fld_permitexpire: response.data.fld_permitexpire,
            fld_dieselappr: response.data.fld_dieselappr,
            fld_remarks: response.data.fld_remarks,
            fld_panno: response.data.fld_panno,
            fld_panaddress: response.data.fld_panaddress,
            fld_panname: response.data.fld_panname,
            fld_favouring: response.data.fld_favouring,
            fld_HireModel : response.data.fld_HireModel
           
        });
      } catch (error) {
        console.error("Error fetching  details:", error);
      }
    };

    fetchLocation();
  }, [id]);


  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

// === labels (for messages) ===
const LABELS = {
  fld_date: "Date",
  branch_code: "Branch",
  fld_vehno: "Vehicle No",
  fld_vcode: "Vehicle Code",
  fld_vname: "Vehicle Name",
  fld_vtype: "Vehicle Type",
  fld_vbasis: "Vehicle Basis",
  fld_vcompanyname: "Company Name",
  fld_ownersname: "Owner's Name",
  fld_vprice: "Vehicle Rent",
  fld_contactperson: "Contact Person",
  fld_address1: "Address 1",
  fld_address2: "Address 2", // optional
  fld_city: "City",
  fld_phone: "Telephone",
  fld_vehappperiod: "Vehicle Approval Period",
  fld_fcexpire: "FC Expiry",
  fld_icexpire: "Insurance Expiry",
  fld_food: "Food",
  fld_tds: "TDS",
  fld_mobile: "Mobile",
  fld_permitexpire: "Permit Expiry",
  fld_dieselappr: "Diesel Approval",
  fld_remarks: "Remarks",
  fld_panno: "PAN No",
  fld_panaddress: "PAN Address",
  fld_panname: "PAN Name",
  fld_favouring: "Favouring",
  fld_HireModel: "Hire Model",
};

// === small helpers ===
const isEmpty = (v) => v === null || v === undefined || String(v).trim() === "";

const isValidPrice = (v) => {
  if (isEmpty(v)) return false;
  const num = Number(v);
  return Number.isFinite(num) && num > 0;
};

// Allows +, spaces, -, (), digits only; and enforces total digit count range.
const isValidPhone = (v) => {
  if (isEmpty(v)) return false;
  const s = String(v).trim();
  if (!/^[+\d\s\-()]+$/.test(s)) return false;
  const digitCount = (s.match(/\d/g) || []).length;
  return digitCount >= 5 && digitCount <= 15;
};

// Try to focus the field (make sure your inputs have id=<fieldKey>)
const focusField = (fieldKey) => {
  const el = document.getElementById(fieldKey);
  if (el && typeof el.focus === "function") {
    el.focus();
    // move caret to end for text-like inputs
    if (el.setSelectionRange && (el.type === "text" || el.type === "tel" || el.type === "number")) {
      const len = el.value?.length ?? 0;
      el.setSelectionRange(len, len);
    }
  }
};

// === Define the *exact order* your form shows fields ===
// Put each field in the order they appear in the UI.
// Optional fields can be omitted or included with required:false.
const FIELD_ORDER = [
  { key: "fld_date", required: true },
  { key: "branch_code", required: true },
  { key: "fld_vehno", required: true },
  { key: "fld_vcode", required: true },
  { key: "fld_vname", required: true },
  { key: "fld_vtype", required: true },
  { key: "fld_vbasis", required: true },
  { key: "fld_vcompanyname", required: true }, // <- your example
  { key: "fld_ownersname", required: true },

  // Vehicle Rent: required, then extra numeric/positive rule immediately after
  { key: "fld_vprice", required: true, extra: "price" },

  { key: "fld_contactperson", required: true },
  { key: "fld_address1", required: true },
  { key: "fld_address2", required: false }, // optional
  { key: "fld_city", required: true },

  // Telephone: required, then format rule immediately after
  { key: "fld_phone", required: true, extra: "phone" },

  { key: "fld_vehappperiod", required: true },
  { key: "fld_fcexpire", required: true },
  { key: "fld_icexpire", required: true },
  { key: "fld_food", required: true },
  { key: "fld_tds", required: true },

  // Mobile: required, then format rule immediately after
  { key: "fld_mobile", required: true, extra: "mobile" },

  { key: "fld_permitexpire", required: true },
  { key: "fld_dieselappr", required: true },
  { key: "fld_remarks", required: true },
  { key: "fld_panno", required: true },
  { key: "fld_panaddress", required: true },
  { key: "fld_panname", required: true },
  { key: "fld_favouring", required: true },
  { key: "fld_HireModel", required: true },
];

// === the new handleSubmit ===
const handleSubmit = async (e) => {
  e.preventDefault();

  // 1) validation (same as you already have)...
  for (const field of FIELD_ORDER) {
    const { key, required, extra } = field;
    const label = LABELS[key] || key;
    const value = formData[key];

    if (required && isEmpty(value)) {
      await Swal.fire({
        icon: "error",
        title: `${label} is required`,
        text: `Please enter ${label.toLowerCase()}.`,
        confirmButtonText: "OK",
      });
      focusField(key);
      return;
    }

    if (!isEmpty(value) && extra === "price" && !isValidPrice(value)) {
      await Swal.fire({
        icon: "error",
        title: "Invalid Vehicle Rent",
        text: "Vehicle rent must be a number greater than 0 (not zero or negative).",
        confirmButtonText: "OK",
      });
      focusField(key);
      return;
    }

    if (!isEmpty(value) && extra === "phone" && !isValidPhone(value)) {
      await Swal.fire({
        icon: "error",
        title: "Invalid Telephone",
        text: "Use digits with optional +, spaces, -, (). Example: 044-494938",
        confirmButtonText: "OK",
      });
      focusField(key);
      return;
    }

    if (!isEmpty(value) && extra === "mobile" && !isValidPhone(value)) {
      await Swal.fire({
        icon: "error",
        title: "Invalid Mobile",
        text: "Use digits with optional +, spaces, -, (). Example: +91 299934933",
        confirmButtonText: "OK",
      });
      focusField(key);
      return;
    }
  }

  // 2) Submit
  try {
    // show loading, but DON'T await it
    Swal.fire({
      title: "Submitting...",
      text: "Please wait while we process your request.",
      allowOutsideClick: false,
      showConfirmButton: false,
      didOpen: () => {
        Swal.showLoading();
      },
    });

    const payload = {
      fld_date: formData.fld_date,
      branch_code: formData.branch_code,
      fld_vehno: formData.fld_vehno,
      fld_vcode: formData.fld_vcode,
      fld_vname: formData.fld_vname,
      fld_vtype: formData.fld_vtype,
      fld_vbasis: formData.fld_vbasis,
      fld_vcompanyname: formData.fld_vcompanyname,
      fld_ownersname: formData.fld_ownersname,
      fld_vprice: formData.fld_vprice,
      fld_contactperson: formData.fld_contactperson,
      fld_address1: formData.fld_address1,
      fld_address2: formData.fld_address2,
      fld_city: formData.fld_city,
      fld_phone: formData.fld_phone,
      fld_vehappperiod: formData.fld_vehappperiod,
      fld_fcexpire: formData.fld_fcexpire,
      fld_icexpire: formData.fld_icexpire,
      fld_food: formData.fld_food,
      fld_tds: formData.fld_tds,
      fld_mobile: formData.fld_mobile,
      fld_permitexpire: formData.fld_permitexpire,
      fld_dieselappr: formData.fld_dieselappr,
      fld_remarks: formData.fld_remarks,
      fld_panno: formData.fld_panno,
      fld_panaddress: formData.fld_panaddress,
      fld_panname: formData.fld_panname,
      fld_favouring: formData.fld_favouring,
      fld_HireModel: formData.fld_HireModel,
    };

    await axios.put(
      `https://rfs2.infraconsoft.net.in/api/edit_hire_master_api/${id}`,
      payload
    );

    // close loading popup
    Swal.close();

    await Swal.fire({
      title: "Success!",
      text: "Updated successfully.",
      icon: "success",
      width: "500px",
      height: "40vh",
      draggable: true,
    });

    navigate("/hire_vehicle_registration_listing");
  } catch (error) {
    console.error("Error submitting form:", error);
    Swal.close(); // ensure loader closes even on error
    await Swal.fire({
      icon: "error",
      title: "Submission failed",
      text: "Something went wrong. Please try again.",
    });
  }
};



if (!canEdit) {
    return (
      <div id="admin-container">
        <AdminNav />
        <div className="content-right" style={{ padding: 20 }}>
          <Access />
        </div>
      </div>
    );
  }

  


  return (
    <div id="admin-container">
      <AdminNav />
      <div className="content-right">
        <section>
        <div className="back-div">
          <h2 className="add-txt">Edit Hire Vehicle</h2>
          <Link to='/hire_vehicle_registration_listing'><p className="back-button"><i className="fa-solid fa-backward"></i>Back</p></Link>
          </div>
          <div>
            <Time />
          </div>
        </section>

        <div className="form-container">
        <form className="vehicle-form" onSubmit={handleSubmit}>
            <div className="form-row">
              <div className="form-group">
                <label>Vehicle Code :</label>
                <input
                  type="text"
                  name="fld_vcode"
                  value={formData.fld_vcode}
                  onChange={handleChange}
                  readOnly
                />
              </div>
              <div className="form-group">
                <label>Vehicle Type:</label>
                <input
                  type="text"
                  name="fld_vtype"
                  value={formData.fld_vtype}
                  onChange={handleChange}
                   readOnly
                />
              </div>
            </div>
            <div className="form-row">
              <div className="form-group">
                <label>Vehicle Register Number:</label>
                <input
                  type="text"
                  name="fld_vehno"
                  value={formData.fld_vehno}
                  onChange={handleChange}
                  readOnly
                />
              </div>
              <div className="form-group">
                <label>Vehicle Basis:</label>
                <input
                  type="text"
                  name="fld_vbasis"
                  value={formData.fld_vbasis}
                  onChange={handleChange}
                  readOnly
                />
              </div> 
            </div>
            <div className="form-row">
              <div className="form-group">
                <label>Vehicle Name:</label>
                <input
                  type="text"
                  name="fld_vname"
                  value={formData.fld_vname}
                  onChange={handleChange}
                  readOnly
                />
              </div>    
              <div className="form-group"></div>           
            </div>
            <h3> Contact Info</h3>
            <div className="form-row">
              <div className="form-group">
                <label>Vehicle Company name:</label>
                <input
                  type="text"
                  name="fld_vcompanyname"
                  value={formData.fld_vcompanyname}
                  onChange={handleChange}
                  
                />
                
              </div>
              <div className="form-group">
                <label>Model :</label>
                <input
                  type="text"
                  name="fld_HireModel"
                  value={formData.fld_HireModel}
                  onChange={handleChange}
                  
                />
                  </div>
            </div>
            <div className="form-row">
              <div className="form-group">
                <label>Address Line 1:</label>
                <input
                  type="text"
                  name="fld_address1"
                  value={formData.fld_address1}
                  onChange={handleChange}
                  
                />
              </div>
              <div className="form-group">
                <label>Address Line 2:</label>
                <input
                  type="text"
                  name="fld_address2"
                  value={formData.fld_address2}
                  onChange={handleChange}
                  
                />
                  </div>
            </div>
            <div className="form-row">
              <div className="form-group">
                <label>Vehicle Rent:</label>
                <input
                  type="text"
                  name="fld_vprice"
                  value={formData.fld_vprice}
                  onChange={handleChange}
                  
                />
              </div>
              <div className="form-group">
                <label>Owner's Name:</label>
                <input
                  type="text"
                  name="fld_ownersname"
                  value={formData.fld_ownersname}
                  onChange={handleChange}
                  
                />
                  </div>
            </div>
            <div className="form-row">
              <div className="form-group">
                <label>City:</label>
                <input
                  type="text"
                  name="fld_city"
                  value={formData.fld_city}
                  onChange={handleChange}
                  
                />
              </div>
              <div className="form-group">
                <label>TelePhone:</label>
                <input
                  type="text"
                  name="fld_phone"
                  value={formData.fld_phone}
                  onChange={handleChange}
                  
                />
                  </div>
            </div>
            <div className="form-row">
              <div className="form-group">
                <label>Contact person:</label>
                <input
                  type="text"
                  name="fld_contactperson"
                  value={formData.fld_contactperson}
                  onChange={handleChange}
                  
                />
              </div>
              <div className="form-group">
                <label>Vehicle Approval Date:</label>
                <input
                  type="date"
                  name="fld_vehappperiod"
                  value={formData.fld_vehappperiod}
                  onChange={handleChange}
                  
                />
                  </div>
            </div>
            <div className="form-row">
              <div className="form-group">
                <label>Mobile no:</label>
                <input
                  type="text"
                  name="fld_mobile"
                  value={formData.fld_mobile}
                  onChange={handleChange}
                  
                />
              </div>
              <div className="form-group">
                <label>FC Expire:</label>
                 <input type="date" name="fld_fcexpire" value={formData.fld_fcexpire ? new Date(formData.fld_fcexpire).toISOString().split('T')[0]: ''} onChange={handleChange}/>
                  </div>
            </div>
            <div className="form-row">
              <div className="form-group">
                <label>Permit Expire:</label>
                <input type="date" name="fld_permitexpire" value={formData.fld_permitexpire ? new Date(formData.fld_permitexpire).toISOString().split('T')[0]: ''} onChange={handleChange}/>
              </div>
              <div className="form-group">
                <label>IC Expire:</label>
                <input type="date" name="fld_icexpire" value={formData.fld_icexpire ? new Date(formData.fld_icexpire).toISOString().split('T')[0]: ''} onChange={handleChange}/>
              
                  </div>
            </div>
            <div className="form-row">
              <div className="form-group">
                <label>Food For Driver:</label>
                <select  name="fld_food"  value={formData.fld_food}   className="branch-select" onChange={handleChange} >
                <option value="">--- Select ---</option>
                <option value="Yes">Yes</option>
                <option value="No">No</option>
            </select>
              </div>
              <div className="form-group">
                <label>TDS:</label>
                <select  name="fld_tds"  value={formData.fld_tds}   className="branch-select" onChange={handleChange} >
                <option value="">--- Select ---</option>
                <option value="Yes">Yes</option>
                <option value="No">No</option>
            </select>
                  </div>
            </div>
            <div className="form-row">
              <div className="form-group">
                <label>Diesel:</label>
                <select  name="fld_dieselappr"  value={formData.fld_dieselappr}  className="branch-select" onChange={handleChange} >
                <option value="">--- Select ---</option>
                <option value="Yes">Yes</option>
                <option value="No">No</option>
            </select>
              </div>
              <div className="form-group">
                <label>Cheque Favouring Name:</label>
                <input
                  type="text"
                  name="fld_favouring"
                  value={formData.fld_favouring}
                  onChange={handleChange}
                  
                />
                  </div>
            </div>
           
            <div className="form-row">
              <div className="form-group">
                <label>PAN Holder Name:</label>
                <input
                  type="text"
                  name="fld_panname"
                  value={formData.fld_panname}
                  onChange={handleChange}
                  
                />
              </div>
              <div className="form-group">
                <label>PAN Card no:</label>
                <input
                  type="text"
                  name="fld_panno"
                  value={formData.fld_panno}
                  onChange={handleChange}
                  
                />
                  </div>
            </div>
           
            <div className="form-row">
              <div className="form-group">
                <label>Mailing Address:</label>
                <input
                  type="text"
                  name="fld_panaddress"
                  value={formData.fld_panaddress}
                  onChange={handleChange}
                  
                />
              </div>
              <div className="form-group">
                <label>Remarks:</label>
                <input
                  type="text"
                  name="fld_remarks"
                  value={formData.fld_remarks}
                  onChange={handleChange}
                  
                />
                  </div>
            </div>
           
            <div className="btn-cls">
              <button type="submit" className="submit-btn">
                Submit
              </button>
            </div>
          </form>
        </div>
        
      </div>
    </div>
  );
};

export default EditHireVehicle;
 